import request from '../utils/request'
/**
 * 
 * @param {*} data 
 * username : admin
 * password : qwe123
 */
// 登录
export const login = function login(data) {
    return request({
        url: 'api/authorizations',
        method: "POST",
        data: JSON.stringify(data)
    })
}
// 编辑
export const AllEdit = function AllEdit(url) {
    return request({
        url,
        method: "GET",
    })
}
// 地址列表
export const car_city = function car_city(e) {
    return request({
        url: "api/car-city",
        method: "GET",
        params: e
    })
}

// 品牌管理
export const car_brand = function car_brand(e) {
    return request({
        url: "api/car-brand",
        method: "GET",
        params: e
    })
}
// 添加
export const addcar_brand = function car_brand(data) {
    return request({
        url: `api/car-brand`,
        method: "POST",
        data: JSON.stringify(data)
    })
}
// 修改
export const modifycar_brand = function car_brand(id, data) {
    return request({
        url: `api/car-brand/${id}`,
        method: "PUT",
        data: JSON.stringify(data)
    })
}
// 删除
export const delcar_brand = function car_brand(id) {
    return request({
        url: `api/car-brand/${id}`,
        method: "DELETE"
    })
}
//车系管理
export const car_series = function car_series(e) {
    return request({
        url: "api/car-series",
        method: "GET",
        params: e
    })
}
// 添加
export const addcar_series = function car_series(data) {
    return request({
        url: `api/car-series`,
        method: "POST",
        data: JSON.stringify(data)
    })
}
// 修改
export const modifycar_series = function car_series(id, data) {
    return request({
        url: `api/car-series/${id}`,
        method: "PUT",
        data: JSON.stringify(data)
    })
}
// 删除
export const delcar_series = function car_series(id) {
    return request({
        url: `api/car-series/${id}`,
        method: "DELETE"
    })
}


//车型管理
export const car_model = function car_model(e) {
    return request({
        url: "api/car-model",
        method: "GET",
        params: e
    })
}
// 添加
export const addcar_model = function car_model(data) {
    return request({
        url: `api/car-model`,
        method: "POST",
        data: JSON.stringify(data)
    })
}
// 修改
export const modifycar_model = function car_model(id, data) {
    return request({
        url: `api/car-model/${id}`,
        method: "PUT",
        data: JSON.stringify(data)
    })
}
// 删除
export const delcar_model = function car_model(id) {
    return request({
        url: `api/car-model/${id}`,
        method: "DELETE"
    })
}

//车友口碑
export const car_score = function car_score(e) {
    return request({
        url: "api/car-score",
        method: "GET",
        params: e
    })
}
// 添加
export const addcar_score = function car_score(data) {
    return request({
        url: `api/car-score`,
        method: "POST",
        data: JSON.stringify(data)
    })
}
// 修改
export const modifycar_score = function car_score(id, data) {
    return request({
        url: `api/car-score/${id}`,
        method: "PUT",
        data: JSON.stringify(data)
    })
}
// 删除
export const delcar_score = function car_score(id) {
    return request({
        url: `api/car-score/${id}`,
        method: "DELETE"
    })
}

//车友价格
export const car_user_price = function car_user_price(e) {
    return request({
        url: "api/car-user-price",
        method: "GET",
        params: e
    })
}
// 添加
export const addcar_user_price = function car_user_price(data) {
    return request({
        url: `api/car-user-price`,
        method: "POST",
        data: JSON.stringify(data)
    })
}
// 修改
export const modifycar_user_price = function car_user_price(id, data) {
    return request({
        url: `api/car-user-price/${id}`,
        method: "PUT",
        data: JSON.stringify(data)
    })
}
// 删除
export const delcar_user_price = function car_user_price(id) {
    return request({
        url: `api/car-user-price/${id}`,
        method: "DELETE"
    })
}

// 团购管理
export const car_group = function car_group(e) {
    return request({
        url: "api/car-group",
        method: "GET",
        params: e
    })
}
// 添加
export const addcar_group = function car_group(data) {
    return request({
        url: `api/car-group`,
        method: "POST",
        data: JSON.stringify(data)
    })
}
// 修改
export const modifycar_group = function car_group(id, data) {
    return request({
        url: `api/car-group/${id}`,
        method: "PUT",
        data: JSON.stringify(data)
    })
}
// 删除
export const delcar_group = function car_group(id) {
    return request({
        url: `api/car-group/${id}`,
        method: "DELETE"
    })
}

//车型价格日志管理
export const car_price_log = function car_price_log(e) {
    return request({
        url: "api/car-price-log",
        method: "GET",
        params: e
    })
}
// 添加
export const addcar_price_log = function car_price_log(data) {
    return request({
        url: `api/car-price-log`,
        method: "POST",
        data: JSON.stringify(data)
    })
}
// 修改
export const modifycar_price_log = function car_price_log(id, data) {
    return request({
        url: `api/car-price-log/${id}`,
        method: "PUT",
        data: JSON.stringify(data)
    })
}
// 删除
export const delcar_price_log = function car_price_log(id) {
    return request({
        url: `api/car-price-log/${id}`,
        method: "DELETE"
    })
}

// 出口车型管理
export const car_special_offer = function car_special_offer(e) {
    return request({
        url: "api/car-special-offer",
        method: "GET",
        params: e
    })
}
// 判断车型 是不是重复 
export const car_special_offer_search = function car_special_offer_search(e) {
    return request({
        url: "api/car-special-offer-search",
        method: "GET",
        params: e
    })
}
// 添加
export const addcar_special_offer = function car_special_offer(data) {
    return request({
        url: `api/car-special-offer`,
        method: "POST",
        data: JSON.stringify(data)
    })
}
// 批量审核
export const addcar_special_offer_auditBatch = function car_special_offer(data) {
    return request({
        url: `api/car-special-offer-auditBatch`,
        method: "POST",
        data: JSON.stringify(data)
    })
}
// 出口价车型批量更新上架状态
export const addcar_special_offer_auditEnable = function car_special_offer(data) {
    return request({
        url: `api/car-special-offer-auditEnable`,
        method: "POST",
        data: JSON.stringify(data)
    })
}
// 出口价车型批量删除
export const addcar_special_offer_auditDelete = function car_special_offer(data) {
    return request({
        url: `api/car-special-offer-auditDelete`,
        method: "POST",
        data: JSON.stringify(data)
    })
}
// 修改
export const modifycar_special_offer = function car_special_offer(id, data) {
    return request({
        url: `api/car-special-offer/${id}`,
        method: "PUT",
        data: JSON.stringify(data)
    })
}
// 删除
export const delcar_special_offer = function car_special_offer(id) {
    return request({
        url: `api/car-special-offer/${id}`,
        method: "DELETE"
    })
}

//活动管理
export const car_activities = function car_activities(e) {
    return request({
        url: "api/car-activities",
        method: "GET",
        params: e
    })
}
// 添加
export const addcar_activities = function car_activities(data) {
    return request({
        url: `api/car-activities`,
        method: "POST",
        data: JSON.stringify(data)
    })
}
// 修改
export const modifycar_activities = function car_activities(id, data) {
    return request({
        url: `api/car-activities/${id}`,
        method: "PUT",
        data: JSON.stringify(data)
    })
}
// 删除
export const delcar_activities = function car_activities(id) {
    return request({
        url: `api/car-activities/${id}`,
        method: "DELETE"
    })
}

//广告管理
export const car_advertising = function car_advertising(e) {
    return request({
        url: "api/car-advertising",
        method: "GET",
        params: e
    })
}
// 添加
export const addcar_advertising = function car_advertising(data) {
    return request({
        url: `api/car-advertising`,
        method: "POST",
        data: JSON.stringify(data)
    })
}
// 修改
export const modifycar_advertising = function car_advertising(id, data) {
    return request({
        url: `api/car-advertising/${id}`,
        method: "PUT",
        data: JSON.stringify(data)
    })
}
// 删除
export const delcar_advertising = function car_advertising(id) {
    return request({
        url: `api/car-advertising/${id}`,
        method: "DELETE"
    })
}

// 汽车用户管理
export const car_user = function car_user(e) {
    return request({
        url: "api/car-user",
        method: "GET",
        params: e
    })
}
// 添加
export const addcar_user = function car_user(data) {
    return request({
        url: `api/car-user`,
        method: "POST",
        data: JSON.stringify(data)
    })
}
// 修改
export const modifycar_user = function car_user(id, data) {
    return request({
        url: `api/car-user/${id}`,
        method: "PUT",
        data: JSON.stringify(data)
    })
}
// 删除
export const delcar_user = function car_user(id) {
    return request({
        url: `api/car-user/${id}`,
        method: "DELETE"
    })
}

//车友报名管理
export const car_user_sign = function car_user_sign(e) {
    return request({
        url: "api/car-user-sign",
        method: "GET",
        params: e
    })
}
// 添加
export const addcar_user_sign = function car_user_sign(data) {
    return request({
        url: `api/car-user-sign`,
        method: "POST",
        data: JSON.stringify(data)
    })
}
// 修改
export const modifycar_user_sign = function car_user_sign(id, data) {
    return request({
        url: `api/car-user-sign/${id}`,
        method: "PUT",
        data: JSON.stringify(data)
    })
}
// 删除
export const delcar_user_sign = function car_user_sign(id) {
    return request({
        url: `api/car-user-sign/${id}`,
        method: "DELETE"
    })
}

// 资讯管理列表
export const carActivitiesList = function carActivitiesList(e) {
    return request({
        url: `api/car-activities`,
        method: "GET",
        params: e
    })
}
// 添加
export const addcarActivitiesList = function addcarActivitiesList(data) {
    return request({
        url: "api/car-activities",
        method: "POST",
        data: JSON.stringify(data)
    })
}
// 修改
export const modifycarActivitiesList = function modifycarActivitiesList(id, data) {
    return request({
        url: `api/car-activities/${id}`,
        method: "PUT",
        data: JSON.stringify(data)
    })
}
// 删除
export const delcarActivitiesList = function delcarActivitiesList(id) {
    return request({
        url: `api/car-activities/${id}`,
        method: "DELETE"
    })
}

// 获取用户列表
export const getUserList = function getUserList() {
    return request({
        url: "api/user",
        method: "GET"
    })
}
// 新添加用户
export const onaddUser = function onaddUser(data) {
    return request({
        url: "api/user",
        method: "POST",
        data: JSON.stringify(data)
    })
}
// 修改用户
export const modifyUser = function modifuUser(id, data) {
    return request({
        url: `api/user/${id}`,
        method: "PUT",
        data: JSON.stringify(data)
    })
}
// 停用用户
export const stopUser = function stopUser(id) {
    return request({
        url: `api/user/${id}`,
        method: "DELETE"
    })
}
// 获取权限列表
export const getPermissionList = function getPermissionList() {
    return request({
        url: "api/permission?pagesize=1000",
        method: "GET"
    })
}
// 新增权限
export const addPermission = function addPermission(data) {
    return request({
        url: "api/permission",
        method: "POST",
        data: JSON.stringify(data)
    })
}
// 修改权限
export const modifyPermission = function modifyPermission(id, data) {
    return request({
        url: `api/permission/${id}`,
        method: "PUT",
        data: JSON.stringify(data)
    })
}
// 停用权限
export const stopPermission = function stopPermission(id) {
    return request({
        url: `api/permission/${id}`,
        method: "DELETE"
    })
}
// 获取角色列表
export const getRoleLise = function getRoleLise() {
    return request({
        url: `api/role`,
        method: "GET"
    })
}
// 新增角色
export const addRole = function addRole(data) {
    return request({
        url: "api/role",
        method: "POST",
        data: JSON.stringify(data)
    })
}
// 修改角色
export const modifyRole = function modifyRole(id, data) {
    return request({
        url: `api/role/${id}`,
        method: "PUT",
        data: JSON.stringify(data)
    })
}
// 停用角色
export const stopRole = function stopRole(id) {
    return request({
        url: `api/role/${id}`,
        method: "DELETE"
    })
}
// 图片上传
export const file_upload_set = function file_upload_set(data) {
    return request({
        url: "api/obs-upload-set",
        method: "POST",
        data
    })
}
// 删除图片
export const obs_upload_delete = function obs_upload_delete(data) {
    return request({
        url: "api/obs-upload-delete",
        header: { "Content-type": "application/x-www-form-urlencoded" },
        method: "POST",
        data:JSON.stringify(data)
    })
}
// 品牌搜索
export const car_brand_search = function car_brand_search() {
    return request({
        url: "api/car-brand-search",
        method: "GET"
    })
}
// 车系搜索
export const car_series_search = function car_series_search(e) {
    return request({
        url: "api/car-series-search",
        method: "GET",
        params: e
    })
}
// 车型搜索
export const car_model_search = function car_model_search(e) {
    return request({
        url: "api/car-model-search",
        method: "GET",
        params: e
    })
}
// 历史记录查询
export const getcarHistory = function getcarHistory(e){
    return request({
        url: "api/car-history",
        method: "GET",
        params: e
    })
}
// 历史记录删除
export const delcarHistory = function delcarHistory(id){
    return request({
        url: `api/car-history/${id}`,
        method: "DELETE"
    })
}
// 销量排行
export const getcarRanking = function getcarRanking(e){
    return request({
        url:"api/car-ranking",
        method:'GET',
        params:e
    })
}
// 添加销量排行
/*
    `brandid` int(11) DEFAULT NULL COMMENT '品牌id',
    `seriesid` int(11) DEFAULT NULL COMMENT '车系id',
    `ranking_sort` int(11) DEFAULT NULL COMMENT '排序',
    `ranking_type` int(11) DEFAULT NULL COMMENT '0：销量排行榜 1：人气排行榜 2：热门车系排行榜（公司合作品牌）',
    `ranking_sales_volume` int(11) DEFAULT NULL COMMENT '销量',
    `ranking_popularity` int(11) DEFAULT NULL COMMENT '人气指数',
    `ranking_region` varchar(50) COLLATE utf8mb4_unicode_ci DEFAULT NULL COMMENT '全国销量、地区销量',
    `ranking_remarks` varchar(50) COLLATE utf8mb4_unicode_ci DEFAULT NULL COMMENT '备注',
*/
export const addcarRabking = function addcarRabking(data){
    return request({
        url:`api/car-ranking`,
        method:"POST",
        data:JSON.stringify(data)
    })
}
// 修改
export const modifycarRabking = function modifycarRabking(id,data){
    return request({
        url:`api/car-ranking/${id}`,
        method:"PUT",
        data:JSON.stringify(data)
    })
}
// 删除
export const delcarRabking = function delcarRabking(id){
    return request({
        url:`api/car-ranking/${id}`,
        method:'DELETE'
    })
}

// 商品列表
export const getcargoods = function getcarGoods(e){
    return request({
        url:"api/car-goods",
        method:'GET',
        params:e
    })
}
// 添加
export const postcargoods = function poscargoods(data){
    return request({
        url:"api/car-goods",
        method:"POST",
        data:JSON.stringify(data)
    })
}
// 修改
export const modifycargoods = function modifycargoods(id,data){
    return request({
        url:"api/car-goods/"+id,
        method:"PUT",
        data:JSON.stringify(data)
    })
}
// 删除
export const delcargooods = function delcargooods(id) {
    return request({
        url:"api/car-goods/"+id,
        method:"DELETE"
    })
}

// 订单列表
// car-good-order
export const getcarOk = function getcarOk(e){
    return request({
        url:"api/car-good-order",
        method:'GET',
        params:e
    })
}
// 添加
export const postcarOk = function postcarOk(data){
    return request({
        url:"api/car-good-order",
        method:"POST",
        data:JSON.stringify(data)
    })
}
// 修改
export const modifycarOk = function modifycarOk(id,data){
    return request({
        url:"api/car-good-order/"+id,
        method:"PUT",
        data:JSON.stringify(data)
    })
}
// 删除
export const delcargoodsOk = function delcargoodsOk(id) {
    return request({
        url:"api/car-good-order/"+id,
        method:"DELETE"
    })
}

// 经销商列表
export const getStores = function getStores(e){
    return request({
        url:"/api/dong-dealer",
        method:'get',
        params:e
    })
}
// 经销商添加
export const addStores = function addStores(data){
    return request({
        url:"/api/dong-dealer",
        method:'POST',
        data:JSON.stringify(data)
    })
}
// 经销商修改
export const modifyStores = function modifyStores(id,data){
    return request({
        url:"/api/dong-dealer/"+id,
        method:'PUT',
        data:JSON.stringify(data)
    })
}
// 经销商删除
export const delStores = function delStores(id){
    return request({
        url:"/api/dong-dealer/"+id,
        method:'DELETE'
    })
}


// 懂车帝车型列表
export const getModels = function getModels(e){
    return request({
        url:"/api/dong-model",
        method:'get',
        params:e
    })
}
// 添加车型
export const addModels = function addModels(data){
    return request({
        url:"/api/dong-model",
        method:'POST',
        data:JSON.stringify(data)
    })
}
// 修改帝车型列表
export const modifyModels = function modifyModels(id,data){
    return request({
        url:"/api/dong-model/"+id,
        method:'PUT',
        data:JSON.stringify(data)
    })
}
// 删除
export const delModels = function delModels(id){
    return request({
        url:"/api/dong-model/"+id,
        method:'DELETE',
    })
}

// 查关联列表
export const getSet = function getSet(e){
    return request({
        url:"/api/dong-object",
        method:'GET',
        params:e
    })
}

// 添加关联列表
export const addSet = function addSet(data){
    return request({
        url:"/api/dong-object",
        method:'POST',
        data:JSON.stringify(data)
    })
}

// 添加关联列表
export const modifySet = function modifySet(id,data){
    return request({
        url:"/api/dong-object/"+id,
        method:'put',
        data:JSON.stringify(data)
    })
}

export const delSet = function delSet(id){
    return request({
        url:"/api/dong-object/"+id,
        method:'DELETE'
    })
}

// 添加数据表
export const addobjectSet = function addobjectSet(data){
    return request({
        url:"/api/dong-object-set",
        method:'POST',
        data:JSON.stringify(data)
    })
}

// 线索列表
export const getuser = function getuser(e){
    return request({
        url:"/api/dong-user",
        method:'get',
        params:e
    })
}
// 添加
export const adduser = function adduser(data){
    return request({
        url:"/api/dong-user",
        method:'POST',
        data:JSON.stringify(data)
    })
}
// 修改
export const modifyuser = function modifyuser(id,data){
    return request({
        url:"/api/dong-user/"+id,
        method:'PUT',
        data:JSON.stringify(data)
    })
}
// 删除
export const deluser = function deluser(id){
    return request({
        url:"/api/dong-user/"+id,
        method:'DELETE',
    })
}

// 获取统计总数
export const carStatistics = function carStatistics(){
    return request({
        url:"/api/car-statistics",
        method:'get',
    })
}


// 获取统计
export const carStatisticsUser = function carStatisticsUser(){
    return request({
        url:"/api/car-statistics-user",
        method:'get',
    })
}

// 清除redis缓存
export const clear_redis_cache = function clear_redis_cache(data) {
    return request({
        url: `api/clear-redis-cache`,
        method: "POST",
        data: JSON.stringify(data)
    })
}